// File: cgp-user-profile-dialog-service.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP User Profile service.
// Other Contributors:

import { Injectable } from "@angular/core";
import { CgpUserProfileDialogComponent } from "./cgp-user-profile-dialog.component";
import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";

const defaults = {
    size: null,
    title: '',

    closeLabel: '',
};

@Injectable()
export class CgpUserProfileDialogService {
    constructor(private readonly dialog: MatDialog) { }

    dialogRef: MatDialogRef<CgpUserProfileDialogComponent>;

    showUserProfileDialog(opts) {
        const options = {
            ...defaults,
            ...opts
        };

        if (this.dialogRef && this.dialogRef.componentInstance) {
            throw new Error('You can only have one User Profile Dialog open at a time.');
        }

        this.dialogRef = this.dialog.open(CgpUserProfileDialogComponent, options);
        this.dialogRef.componentInstance.title = options.title;
        this.dialogRef.componentInstance.closeLabel = options.closeLabel;

        return this.dialogRef;
    }
}
